import React from "react";

export default function ChapterHeader({title, ord, book, loading}) {
    if (loading) {
        return (
            <div className="text-center mb-8 md:mb-12 pb-6 md:pb-8 border-b border-paper-deep relative animate-pulse">
                <span
                    className="absolute -bottom-[11px] left-1/2 -translate-x-1/2 bg-paper px-4 text-gold/30 text-sm">❖</span>
                <p className="text-[11px] tracking-[6px] text-ink-faint/30 mb-3">加载中…</p>
                <div className="h-7 md:h-9 w-40 md:w-48 bg-paper-deep/50 rounded mx-auto"/>
                <div className="h-4 w-20 md:w-24 bg-paper-deep/30 rounded mx-auto mt-4"/>
            </div>
        );
    }
    return (
        <div className="text-center mb-8 md:mb-12 pb-6 md:pb-8 border-b border-paper-deep relative">
            <span className="absolute -bottom-[11px] left-1/2 -translate-x-1/2 bg-paper px-4 text-gold text-sm">❖</span>
            <p className="text-[10px] md:text-[11px] tracking-[4px] md:tracking-[6px] text-vermilion mb-2 md:mb-3">第 {ord + 1 ?? '—'} 章</p>
            <h2 className="font-display text-[24px] md:text-[32px] tracking-[8px] md:tracking-[12px] text-ink leading-snug">
                {title || '—'}
            </h2>
            <p className="text-[10px] md:text-xs text-ink-faint tracking-[2px] md:tracking-[4px] mt-3 md:mt-4">{book} ·
                战国</p>
        </div>
    );
}
